// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__34H7d","filesListContainer":"PosDisputesFiles_filesListContainer__2iZGA","filesButton":"PosDisputesFiles_filesButton__1E9P-"};